import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Chevron from '../../assets/images/home/chevron-right-grey.svg';
import ProductIcon from '../../assets/images/home/product-available.svg';
import AvailableProductsModal from './AvailableProductsModal';
import { getAvailableProducts, getAvailableProductsCancelToken } from '../../actions/landingPage';
import { gaEvents } from '../../utils/events';

const ProductsAvailable = ({ data, token, history }) => {
  const [showAvailableProducts, setShowAvailableProducts] = useState(false);
  const [availableProducts, setAvailableProducts] = useState([]);
  const title = get(data, 'title', '');
  const subtitle = get(data, 'sub_title', '');

  useEffect(() => {
    if (showAvailableProducts && !availableProducts.length) {
      getAvailableProducts(token).then((res) => {
        if (res) {
          setAvailableProducts(res);
        }
      });
    }

    return () => {
      if (getAvailableProductsCancelToken) getAvailableProductsCancelToken();
    };
  }, [showAvailableProducts]);

  return (
    <>
      <div
        className="cursor-pointer feed-product-available"
        onClick={() => {
          gaEvents.landingpage.productAvailable();
          setShowAvailableProducts(true);
        }}
      >
        <img src={ProductIcon} />
        <div className="feed-product-available__text">
          <span className="feed-product-available__text__title">{title}</span>
          <div className="feed-product-available__text__cta">
            <span className="feed-product-available__text__cta__text">{subtitle}</span>
            <img src={Chevron} className="feed-product-available__text__cta__icon" />
          </div>
        </div>
      </div>
      {showAvailableProducts && availableProducts.length > 0 && (
        <AvailableProductsModal
          data={availableProducts}
          closeModal={() => {
            setShowAvailableProducts(false)
          }}
          history={history}
        />
      )}
    </>
  );
};

ProductsAvailable.propTypes = {
  data: PropTypes.object,
  token: PropTypes.string,
  history: PropTypes.object,
};

export default ProductsAvailable;
